import { useCallback, useEffect, useState } from 'react';

const useMediaQuery = (query: string): boolean => {
  const getMatches = useCallback(
    (query: string): boolean => window.matchMedia(query).matches,
    [],
  );

  const [matches, setMatches] = useState<boolean>(
    window.matchMedia(query).matches,
  );

  const handleChange = useCallback(() => {
    setMatches(getMatches(query));
  }, [getMatches, query]);

  useEffect(() => {
    const matchMedia = window.matchMedia(query);
    matchMedia.addEventListener('change', handleChange);
    return () => matchMedia.removeEventListener('change', handleChange);
  }, [handleChange, query]);

  return matches;
};

export default useMediaQuery;
